import React from 'react';
import withContentWrapper from 'Common/HOC/withContentWrapper';
import Callback from '../components/Callback';

const CallbackScreen: React.FC = () => <Callback />;

export default withContentWrapper(CallbackScreen);
